
let GalleryPopup = function ($el, options) {

    this.options = { ...this.defaultOptions, ...options };

    this.$root = $el;
    this.$content = $(document).find(this.options.content.class);

    this.currentSlide = 0;
    this.initialImageToShow = 0;

    this.init();

};

GalleryPopup.prototype.init = function () {

    /**
     * Slick Slider
     */

    if (typeof this.$content.data("image") !== 'undefined') {
        this.initialImageToShow = parseInt(this.$content.data("image"));
    }

    this.totalSlides = $(this.options.sliderNav.class).find('img').length;

    $(this.options.sliderViewer.class).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: false,
        fade: true,
        infinite: true,
        mobileFirst: true,
        asNavFor: this.options.sliderNav.class
    });

    $(this.options.sliderViewer.class).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var newImg = $(slick.$slides[nextSlide]).find('img');

        if (!newImg.attr('img') && !!newImg.data('src')) {
            newImg.attr("src", newImg.data('src'));
            newImg.data('src', null)
        }

        var nextIndex;

        if (nextSlide > currentSlide) { // forward
            nextIndex = nextSlide + 1;
        } else { // backwards
            nextIndex = nextSlide - 1;
        }

        if (nextIndex in slick.$slides) {
            var img = $(slick.$slides[nextIndex]).find('img');
            var url = img.data('src');

            if (!!url) {
                img.attr("src", url);
                img.data('src', null)
            }
        }
    });

    $(this.options.sliderNav.class).slick({
        slidesToScroll: 1,
        asNavFor: this.options.sliderViewer.class,
        dots: false,
        infinite: true,
        centerMode: true,
        mobileFirst: true,
        variableWidth: true,
        prevArrow: $(this.options.sliderNav.class).find('[data-action="slick-prev"]'),
        nextArrow: $(this.options.sliderNav.class).find('[data-action="slick-next"]'),
        focusOnSelect: true,
    });

    /**
     * Event Handlers
     */
    $(this.$content).on('click', '[data-action="slick-prev"]', () => {
        $(this.options.sliderViewer.class).slick('slickPrev');
    });

    $(this.$content).on('click', '[data-action="slick-next"]', () => {
        $(this.options.sliderViewer.class).slick('slickNext');
    });

    $(this.options.sliderNav.class).on('afterChange', () => {
        this.updateCurrentSlide();
        this.updateContent();
    });

    if (this.initialImageToShow > 0) {
        $(this.options.sliderViewer.class).slick('slickGoTo', this.initialImageToShow, false)
    }
};

GalleryPopup.prototype.updateContent = function () {

    let currentSlide = $(this.options.sliderNav.class).slick('slickCurrentSlide');

    const target = $(this.options.sliderViewer.class).find(`[data-slick-index="${currentSlide}"]`);

    if (target.length > 0) {

        const text = $(target).find('img').data('description');
        this.$content.find('[data-type="content"]').text(text);

    } else {

        this.$content.find('[data-type="content"]').text("No description provided");
    }

};

GalleryPopup.prototype.updateCurrentSlide = function () {

    let currentSlide = $(this.options.sliderNav.class).slick('slickCurrentSlide');
    this.$content.find('[data-type="index"]').text(currentSlide + 1);

    this.currentSlide = currentSlide;
};

/**
 * Return the default configuration options
 */
GalleryPopup.prototype.defaultOptions = {
    content: {
        class: '.album-gallery-popup-container'
    },
    sliderNav: {
        class: '.gallery-slider-nav'
    },
    sliderViewer: {
        class: '.gallery-slider-viewer'
    }
};

export default GalleryPopup;